import { useTranslation } from 'react-i18next';
import { useConfiguration } from '../../hooks/useConfiguration';
import React from 'react';
import { AboutItem } from './aboutItem';
import { resolvePath } from '../../utils/resolvePath';

export const Version: React.FC = () => {
  const configuration = useConfiguration();

  const { t } = useTranslation();

  if (configuration === undefined) {
    return null;
  }

  const { stageVersion, releaseDate, udiCompanyIdentifier } = configuration;

  const releaseDateDate = new Date(Date.parse(releaseDate));
  const releaseDateText = `${releaseDateDate.getFullYear()}-${String(releaseDateDate.getMonth() + 1).padStart(2, '0')}-${String(releaseDateDate.getDate()).padStart(2, '0')}`;

  return (
    <>
      <h2>{t('about.version.title')}</h2>
      <AboutItem title={t('about.version.currentVersion')} contentWeight='bold'>
        {stageVersion}
      </AboutItem>
      <AboutItem src={resolvePath('release_date.png')} contentWeight='bold' alt='release date'>
        {releaseDateText}
      </AboutItem>
      <AboutItem src={resolvePath('udi.png')} contentWeight='bold' alt='UDI'>
        {udiCompanyIdentifier}{stageVersion}
      </AboutItem>
      <AboutItem src={resolvePath('ref.png')} contentWeight='bold' alt='Ref'>
        WM 29610
      </AboutItem>
    </>
  );
};